import {
  LinkPreviewProviders,
  RicosViewer as BaseRicosViewer,
  pluginCodeBlockViewer as pluginCodeBlock,
  pluginEmojiViewer as pluginEmoji,
  pluginHashtagViewer as pluginHashtag,
  pluginIndentViewer as pluginIndent,
  pluginLineSpacingViewer as pluginLineSpacing,
  pluginSpoilerViewer as pluginSpoiler,
} from '@wix/ricos'
import {
  pluginAudioLoadable as pluginAudio,
  pluginCollapsibleListLoadable as pluginCollapsibleList,
  pluginDividerLoadable as pluginDivider,
  pluginFileUploadLoadable as pluginFileUpload,
  pluginGalleryLoadable as pluginGallery,
  pluginGiphyLoadable as pluginGiphy,
  pluginHtmlLoadable as pluginHtml,
  pluginImageLoadable as pluginImage,
  pluginLinkLoadable as pluginLink,
  pluginLinkPreviewLoadable as pluginLinkPreview,
  pluginVideoLoadable as pluginVideo,
} from '@wix/ricos/loadable'
import {EVENTS_APP_ID} from '@wix/wix-events-commons-statics'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React, {ComponentProps, useMemo} from 'react'
import {getBaseUrl} from '../../../../../../commons/selectors/environment'
import {getInstance, getMetaSiteId} from '../../../../../../commons/selectors/instance'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {RicosViewerProps} from './interfaces'
import '@wix/ricos/css/ricos-viewer.global.css'
import '@wix/ricos/css/plugin-hashtag-viewer.global.css'
import '@wix/ricos/css/plugin-spoiler-viewer.global.css'
import '@wix/ricos/css/plugin-link-viewer.global.css'

export const RicosViewer = ({content}: RicosViewerProps) => {
  const {isMobile} = useEnvironment()

  const event = useAppSelector(getEvent)
  const instance = useAppSelector(getInstance)
  const msid = useAppSelector(getMetaSiteId)
  const baseUrl = useAppSelector(getBaseUrl)

  const plugins = useMemo(() => createPlugins(baseUrl), [baseUrl])

  return (
    <BaseRicosViewer
      content={content}
      instance={instance}
      msid={msid}
      plugins={plugins}
      theme={theme}
      isMobile={isMobile}
      baseUrl={baseUrl}
      biSettings={{consumer: 'Events', postId: event.id, containerId: EVENTS_APP_ID, platform: 'Livesite'}}
    />
  )
}

const createPlugins = (siteUrl?: string) => [
  pluginAudio(),
  pluginCodeBlock(),
  pluginCollapsibleList(),
  pluginDivider(),
  pluginEmoji(),
  pluginFileUpload(),
  pluginGallery(),
  pluginGiphy(),
  pluginHashtag(),
  pluginHtml(),
  pluginImage(),
  pluginIndent(),
  pluginLineSpacing(),
  pluginLink(siteUrl ? {siteUrl} : undefined),
  pluginLinkPreview({
    exposeEmbedButtons: [LinkPreviewProviders.Instagram, LinkPreviewProviders.Twitter, LinkPreviewProviders.TikTok],
  }),
  pluginSpoiler(),
  pluginVideo(),
]

const theme: ComponentProps<typeof BaseRicosViewer>['theme'] = {
  useWixStyles: true,
  typography: {
    fontFamily: 'var(--aboutSectionFontV2-family)',
  },
  colorPalette: {
    format: 'rgbTuple',
    accent1: 'var(--linkColorV2)',
    textColor: 'var(--aboutSectionColorV2)',
  },
}
